import React, { useEffect, useState } from 'react';
import { getObjectValue, replaceAll } from '../../../utility/utills';
import { COUNTRY_CODE } from '@constants/index';
import cn from 'classnames';
import style from './smsReceipt.module.scss';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import { useSelector } from 'react-redux';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';


const SmsReceipt = (props) => {
    const { setPopup, onSubmit, defaultPhoneNumber } = props;
    const auth = JSON.parse(window?.sessionStorage?.getItem('auth'));
    const defaultCountryCode = getObjectValue(() => COUNTRY_CODE[auth?.country].dialCode, '1');
    const [countryCode, setCountryCode] = useState(defaultCountryCode);
    const [inputs, setInputs] = useState({ "phoneNumber": '' });
    const [error, setError] = useState('');
    const serverAppTheme = useSelector(state => state.theme.serverAppTheme);

    useEffect(() => {
        setInputs({
            phoneNumber: Number(countryCode) === 1
                ? getFormatedPhoneNumber(defaultPhoneNumber)
                : defaultPhoneNumber
        })
    }, [defaultPhoneNumber])

    const handleChange = (e) => {
        let rawValue = e.target.value.replace(/\D/g, '');
        const maxLen = Number(countryCode) === 1 ? 10 : 15;
        rawValue = rawValue.slice(0, maxLen);

        const formattedValue = Number(countryCode) === 1
            ? getFormatedPhoneNumber(rawValue)
            : rawValue;

        setInputs({ phoneNumber: formattedValue });
    }
    const getInputValue = () => {
        return (inputs["phoneNumber"]) || '';
    }
    const returnMaxLength = (countryCode) => {
        if (Number(countryCode) === 1) {
            return 12;
        }
        return 15;
    };
    const handleCountryCodeChange = (e) => {
        setInputs({ phoneNumber: '' });
        returnMaxLength(e.id);
        setCountryCode(e.id);
    }
    const validatePhoneNumber = phoneNumber => {
        let inputError = "";
        const inputValue = replaceAll(phoneNumber, '-');
        if (!inputValue) {
            inputError = FLABEL().RECEIPT_ERROR_PHONE
        } else if (countryCode === '1' && inputValue.length != 10) {
            inputError = FLABEL().RECEIPT_PHONE_DIGITS_ERROR
        } else if (countryCode != '1' && inputValue?.length > 15) {
            inputError = "Phone number requires 15 digits"
        }
        return inputError;
    }
    const handleDone = () => {
        let isValid = validatePhoneNumber(inputs["phoneNumber"]);
        if (!isValid) {
            setError('');
            onSubmit(inputs["phoneNumber"], countryCode);
        } else {
            setError(isValid)
        }

    }
    return (
        <div className={cn('w-100 h-100', style.smsContainer)}>
            <div className="w-100 h-100 position-relative">
                <div className={cn('d-flex flex-column mb-6', style.smsInputConatiner)}>
                    <label className={cn('block fs-12 mb-0', style.smsHeader)}>{FLABEL().RECEIPT_PHONE_NUMBER}</label>
                    <div className={cn('w-100 position-relative', style.phoneNumberContainer)}>
                        <PhoneNumberComponent
                            countryCode={countryCode}
                            maxMenuHeight={200}
                            isCustomWidth={style.smsPhoneDropDownConatiner}
                            handleCountryCodeChange={(e) => handleCountryCodeChange(e)}
                            serverAppTheme={serverAppTheme}
                        />
                        <input
                            name="phoneNumber"
                            maxLength={returnMaxLength(countryCode)}
                            placeholder={FLABEL().RECEIPT_ENTER_PHONE}
                            className={cn("w-100 h-100 d-flex align-items-center focus:border-blue-500 focus:outline-none placeholder-gray-500", style.smsInput, style.plInupt)}
                            onChange={(e) => { handleChange(e); setError('') }}
                            value={getInputValue()}
                        />
                    </div>
                </div>
                <span className={style.errorTextColor}>{error ? error : <>&nbsp;</>}</span>
                <div className={cn('w-100', style.smsbuttoncontainer)}>
                    <button className={cn('w-35', style.smsbtn, style.smscancelbtn)} onClick={() => setPopup(null)}>{FLABEL().RECEIPT_CANCEL}</button>
                    <button className={cn('w-35', style.smsbtn, style.smsdonebtn)} onClick={handleDone}>{FLABEL().RECEIPT_DONE}</button>
                </div>
            </div>
        </div>
    )
}

export default SmsReceipt;